export default [
  {
    name: 'vip-id',
    path: 'vip/:id',
    component: () => import(/* webpackChunkName: "vip-id" */ '@/views/Vip'),
    meta: {
      keepAlive: false
    }
  },
  {
    name: 'vip-related',
    path: 'vip-related/:vipId',
    component: () => import(/* webpackChunkName: "vip-related" */ '@/views/Vip/Related'),
    meta: {
      keepAlive: false
    }
  }
]
